import { Button } from '@/components/shadcn/button'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { ErrorBoundary } from 'react-error-boundary'
import { IconBg } from '@/components/ui/IconBg'
import { IconV2AlertOutline } from '@icons/IconV2AlertOutline'

export function QueryErrorBoundary({
  children,
  errorMessage,
}: {
  children: React.ReactNode
  errorMessage: React.ReactNode
}) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={({ resetErrorBoundary }) => (
            <ErrorBoundaryContent errorMessage={errorMessage} resetErrorBoundary={resetErrorBoundary} />
          )}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}

export function ErrorBoundaryContent({
  errorMessage,
  resetErrorBoundary,
}: {
  errorMessage?: React.ReactNode
  resetErrorBoundary?: () => void
}) {
  return (
    <div className="mt-16 flex size-full justify-center">
      <div className="flex max-h-fit flex-col items-center gap-y-6 rounded-lg p-4">
        <div className="flex items-center gap-4 rounded-md">
          <IconBg variant="error" className="size-10">
            <IconV2AlertOutline className="size-7 -translate-y-[1px]" />
          </IconBg>
          {errorMessage}
        </div>
        <Button size="sm" variant="destructive" onClick={() => resetErrorBoundary?.()}>
          Try again
        </Button>
      </div>
    </div>
  )
}
